import { Component, OnInit, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SiteConfigurationService } from '../../common/site-configuration.service'; 
import * as myGlobals from '../../global';
import { FillerService } from '../../common/Service_tnFiller';

@Component({
  selector: 'app-tnhomeslider',
  templateUrl: '../../themes/default/html/tnhomeslider.component.html',
  styleUrls: ['../../themes/default/css/tnhomeslider.component.scss']
})
export class TnhomesliderComponent implements OnInit {
  defaultSchema  = {
    limit: 0,
    offset: 0,
    codes: [],
    buildFloorsPlusThen: 0,
    listKind: "HomeVisible",
    adsIDs: [],
    categoryId: 0,
    groupId: 0,
    typeId: 0,
    rentKindId: 0,
    cityName: "",
    cityZoneId: 0,
    conditioner: false,
    garage: false,
    garden: false,
    animalAdmit: false,
    balcony: false,
    bathroomsPlusThan: 0,
    buildable: false,
    carParkPlusThan: 0,
    lift: false,
    panoramic: false,
    priceRange: [],
    radiators: false,
    roomsPlusThan: 0,
    surfaceRange: [],
    orderByKind: "Id",
    orderByDir: "ASC",
    uiCulture: "it"
};
  homeSlides: any = [];
  _mySettings: any;
  slideurl: any = myGlobals.apiBasePath;
  private refcreated: any = false;
  private listfilled = false;
  private initdone = false;
 
  public randomar: number[] = [0];

  constructor(private mySettings: SiteConfigurationService, private elementRef:ElementRef, private filler: FillerService,private sanitizer: DomSanitizer) {
      this._mySettings = mySettings.getFullConfig();
      this.homeSlides = this._mySettings.e400.site.homeSlideShow;
   }

 
  ngOnInit() {
    if (this.listfilled==true) { return }
    this.UpdateFiller();
  }

  UpdateFiller() {
    new Promise((resolve, reject) => {
      this.filler.Get_AdsList(this.defaultSchema).subscribe(
          data => {
            let i = 0;
            this.randomar = [];
            while (i < data.Count){
              let rn = Math.floor(Math.random() * data.Count) + 1;
              if(!this.randomar.includes(rn - 1)){
                this.randomar.push(rn - 1);
                i++;
              }
            }
            this.defaultSchema = Object.assign([], data.Items);
            this.listfilled=true;
            resolve(true);
          }, err => { console.log(err); }
        );
    }).then(
      e => this.CreateReference()
    );
    
}

  

// get random item from json array

  ngAfterContentInit() {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    
  }

  ngAfterViewInit() {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    
  }

  ngAfterContentChecked() {
    if (!this.refcreated) {
      //this.CreateReference();
      this.refcreated = true;
    }
      
  }

  CreateReference() {

      // var s;
      // try {
      //     s = document.createElement("script");
      // } catch (e) {
      //     return;
      // }
      // //s.id = "SwipererBig";
      // s.type = "text/javascript";
      // s.src="./assets/script.js";
      // this.elementRef.nativeElement.appendChild(s);
      
      // this.initdone = true;
      // if (this.initdone) { return; }

  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnhomeslider/tnhomeslider.component.ts